import { alpha, lighten } from "@mui/system";

const styles = (theme) => ({
  containerComponent: {
    width: "100%",
    p: 1,
  },
  boxContainer: {
    borderRadius: 2,
    p: 2.5,
    mb: 1.5,
    textAlign: "center",
    transition: "0.2s",
    minHeight: "150px",
    maxHeight: "350px",
    overflowY: "auto",
  },
  boxImagePreview: {
    position: "relative",
    borderRadius: 2,
    border: `1px solid ${alpha(theme.palette.text.primary, 0.25)}`,
    overflow: "hidden",
    textAlign: "center",
    p: 1,
    backgroundColor: theme.palette.background.paper,
    transition: "0.2s",
  },
  avatar: {
    width: "100%",
    height: 80,
    objectFit: "cover",
    borderRadius: 2,
  },
  boxTitleAnexo: {
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    px: 0.5,
    pt: 0.5,
  },
  boxTextAnexo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "11px",
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  containerCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: 80,
    gap: 0.5,
  },
  iconButton: {
    position: "absolute",
    top: 3,
    right: 3,
    zIndex: 5,
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: lighten(theme.palette.secondary.main, 0.2),
    },
  },
  textInfo: {
    mb: 1,
    fontSize: "13px",
  },
});

export default styles;
